// src/components/profile/MypostProperty.js
import { FaBed, FaBath, FaRulerCombined, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { API_URL } from "../../../config/api"; 

export default function MypostProperty({ property, onEdit, onDelete }) {
    // Xử lý ảnh: parse JSON nếu property.images là string
    let imageSrc = "/no-image.jpg";
    try {
        const images = Array.isArray(property.images)
            ? property.images
            : JSON.parse(property.images || "[]");

        if (images.length > 0) {
            // Kiểm tra xem image có phải là URL đầy đủ không
            if (images[0].startsWith("http")) {
                imageSrc = images[0];
            } else {
                imageSrc = `${API_URL}${images[0]}`;
            }
        }
    } catch {
        imageSrc = "/no-image.jpg";
    }

    // Loại bất động sản
    const typeMap = {
        apartment: "Căn hộ",
        villa: "Biệt thự",
        shophouse: "Shophouse",
        condotel: "Condotel",
        penthouse: "Penthouse",
        duplex: "Duplex",
    };

    // Trạng thái duyệt tin
    const statusColor = {
        pending: "bg-yellow-500",
        approved: "bg-green-600",
        rejected: "bg-red-500",
    }[property.status];

    // Giá hiển thị
    const displayPrice =
        property.transactionType === "rent"
            ? property.rentPrice
                ? `${property.rentPrice.toLocaleString("vi-VN")} ₫ / tháng`
                : "Giá thuê thỏa thuận"
            : property.price
                ? `${property.price.toLocaleString("vi-VN")} ₫`
                : "Giá bán thỏa thuận";

    return (
        <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition flex flex-col">
            <Link to={`/properties/${property.id}`} className="relative">
                <img src={imageSrc} alt={property.title} className="w-full h-48 object-cover" />
                <span
                    className={`absolute top-2 left-2 text-xs text-white px-2 py-1 rounded ${statusColor}`}
                >
                    {property.status === "approved"
                        ? "Đã duyệt"
                        : property.status === "pending"
                            ? "Chờ duyệt"
                            : "Từ chối"}
                </span>

                <span
                    className={`absolute top-2 right-2 text-xs px-2 py-1 rounded ${property.transactionType === "rent"
                        ? "bg-blue-600 text-white"
                        : "bg-red-600 text-white"
                        }`}
                >
                    {property.transactionType === "rent" ? "Cho thuê" : "Bán"}
                </span>
            </Link>

            <div className="p-3 text-sm text-blue-900 space-y-1 flex flex-col flex-1">
                <h3 className="font-semibold text-base line-clamp-2">
                    {property.projectName || property.title}
                </h3>
                <p className="text-gray-600 text-xs">{typeMap[property.propertyType]}</p>

                <div className="flex justify-between flex-wrap gap-2 text-gray-700 text-xs">
                    <span className="flex items-center gap-1">
                        <FaBed /> {property.bedrooms} PN
                    </span>
                    <span className="flex items-center gap-1">
                        <FaBath /> {property.bathrooms} PT
                    </span>
                    <span className="flex items-center gap-1">
                        <FaRulerCombined /> {property.area} m²
                    </span>
                </div>

                <p className="text-red-600 font-bold text-lg">{displayPrice}</p>

                <p className="text-xs text-gray-500 flex items-center gap-1 mt-auto">
                    <FaMapMarkerAlt /> {property.location}
                </p>

                {onEdit && onDelete && (
                    <div className="flex justify-between mt-3">
                        <button
                            onClick={() => onEdit(property)}
                            className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Sửa
                        </button>
                        <button
                            onClick={() => onDelete(property.id)}
                            className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                        >
                            Xóa
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
